import { type Dispatch, type SetStateAction, useState } from "react";
import { useSearchParams } from "next/navigation";
import { STORE_LOCATOR_SEARCH_PARAMS, PARTNER_STORES_PARAM_VALUES } from "../constants";

export const useShowPartnerStores = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
    const searchParams = useSearchParams();
    const param = searchParams.get(STORE_LOCATOR_SEARCH_PARAMS.PARTNER_STORES);
    const [showPartnerStores, setShowPartnerStores] = useState(
        param !== PARTNER_STORES_PARAM_VALUES.OFF
    );
    return [showPartnerStores, setShowPartnerStores];
};
